/** GA4 recommended ecommerce item (no PII). */
export type GaEcommerceItem = {
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
  item_category?: string;
  item_variant?: string;
};

export const DEFAULT_GA_ECOMMERCE_CURRENCY = 'IDR' as const;

export type GaEcommerceCurrency = typeof DEFAULT_GA_ECOMMERCE_CURRENCY;

export type GaEcommerceCheckoutContext = {
  payLink: string;
  value: number;
  currency: GaEcommerceCurrency;
  items: GaEcommerceItem[];
};

export const GA_ECOMMERCE_CHECKOUT_STORAGE_KEY = 'ga_ecommerce_checkout';
